import separateThumbs from "../../utils/separateThumbs";

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/intro', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));

const { media, thumbs } = separateThumbs(allMedia)

export const intro = {
    title: 'Chili Garlic Spicy Noodles',
    description: 'Slightly spicy vegan noodles with garlic & gochujang',
    prepTime: 10,
    cookTime: 15,
    totalTime: 25,
    media: media,
    thumbnails: thumbs,
    storySummary: `15 minutes and only 8 ingredients for some extra delicious garlicky spicy noodles! These noodles are saucy, spicy, a little bit sweet, and full of umami. They’re extra garlicky and vegan! Of course, you can add extra protein and veggies to this to bulk it up and make it a whole meal. These noodles are super versatile and the best part is that they come together amazingly quickly.`,
    storyMore: ``,
    keywords: ['noodles', 'spicy', 'Korean', 'gochujang', 'sweet & spicy'],
    recipeCategory: ['dinner'],
    cuisine: ["American","Korean"],
    id: 'chili-garlic-spicy-noodles',
    author: 'Saigon Social'
}